import { post } from '@/api'

/**
 * 登录
 * @param {{ phone: string, password: string }} data
 * @returns {Promise<{ token, userId, username, phone, email, avatar, status }>}
 */
export function login(data) {
  return post('/login', data)
}

/**
 * 发送短信验证码
 * @param {{ phoneNumber: string }} data
 */
export function sendSmsCode(data) {
  return post('/sms/send-code', data)
}

/**
 * 忘记密码 / 重置密码
 * @param {{ phoneNumber: string, verificationCode: string, newPassword: string, confirmNewPassword: string }} data
 */
export function forgotPassword(data) {
  return post('/login/forgot-password', data)
}
